import config from 'config';

import { createSelector } from '../../techstyle-shared/redux-core';

export const getTldLocale = createSelector(
  [(state) => state.domain.tld],
  (tld) => {
    const userAttributesLocale = config.get('public.intl.builderLocales')[tld];
    return userAttributesLocale;
  }
);
